import CollapsibleFieldTemplate from "./CollapsibleFieldTemplate";

export default CollapsibleFieldTemplate;